import React from 'react'
import TailoredInput from 'ui-shared/Tailored/TailoredInput'
import MultiImageInput from 'ui-shared/WrappedInputs/MultiImageInput'
import ProductForm, { ProductFormProps } from './ProductForm'

export type MainProductFormProps = ProductFormProps & {
  disableTailoredValidation?: boolean
}

const MainProductForm: React.FC<MainProductFormProps> = ({
  facetFields,
  children,
  disableTailoredValidation = false,
  ...props
}) => {
  return (
    <ProductForm {...props} slotBeforeFacets={<MultiImageInput />}>
      {facetFields}
      {children}

      <TailoredInput
        disableValidation={disableTailoredValidation}
        validationMessage="form.fields.productInSectionValidation"
      />
    </ProductForm>
  )
}

export default MainProductForm
